import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { OkResponse } from "@typings/api";
import type { CreateAdditionalDataAttachmentsDTO } from "./type";

export async function createAdditionalDataAttachments(
  attachments: CreateAdditionalDataAttachmentsDTO,
): Promise<OkResponse> {
  const formData = new FormData();
  attachments.files.forEach((file) => formData.append("media", file));

  const response = await apiClient.post<OkResponse>(
    apiPaths.individuals.additionalData.createAttachments({
      individualId: attachments.id,
      additionalDataId: attachments.additionalDataId,
    }),
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );

  return response.data;
}
